import { render, staticRenderFns } from "./ComissaoNaoConformidade.vue?vue&type=template&id=9158da5a&scoped=true"
import script from "./ComissaoNaoConformidade.vue?vue&type=script&lang=js"
export * from "./ComissaoNaoConformidade.vue?vue&type=script&lang=js"
import style0 from "./ComissaoNaoConformidade.vue?vue&type=style&index=0&id=9158da5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9158da5a",
  null
  
)

export default component.exports